import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import Fileuploader from "../Components/Fileuploader";
import {
  deleteMedicalreport,
  getPatientmedicalreporstapi,
} from "../network/Network";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

const UserMyMedicalReport = () => {
  const token = useSelector((state) => state?.Auth?.token);
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [files, setFiles] = useState([]);
  const [getMedicalreport, setGetMedicalreport] = useState([]);

  const handleFileUploadClick = (index) => {
    document.getElementById(`file-input`).click();
  };

  const handleCancelClick = (setFile) => {
    setFile(null);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission
  };

  // Handle file selection
  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };

  // Handle file removal
  const handleRemoveFile = (index) => {
    const newFilesArray = files.filter((_, i) => i !== index);
    setFiles(newFilesArray);

    // Clear the input field
    document.getElementById("file-input").value = "";
  };

  // Delete Medical Report
  const Deletemedicalreport = (e, id) => {
    e.preventDefault();
    deleteMedicalreport(id, token)
      .then((res) => {
        // Filter out the deleted report by its ID
        setGetMedicalreport((prevReports) =>
          prevReports.filter((report) => report.id !== id)
        );

        // Show success message
        Swal.fire({
          position: "center",
          icon: "success",
          text: "Medical Report Has Been Deleted",
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((err) => {
        // Optionally, you can show an error message here
      });
  };
  // ======================

  return (
    <>
      <Header />
      <PageHeader pagename="User Profile" />
      <section className="main-sidebar user-profile">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <UserProfileSidebar />
            </div>
            <div className="col-lg-8">
              <div className="main-profile-content radius-20 p-4">
                <div className="main-headind d-flex align-items-center 	gap-3 mb-3">
                  <div className="edit-btn back">
                    <Link to="/upload-medical-reports">
                      <div className="nav-anchor">
                        <i className="fa-solid fa-arrow-left"></i>
                      </div>
                    </Link>
                  </div>
                  <h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
                    Upload Medical Reports
                  </h5>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="row input-file-wrapper">
                    <div className="form-group col-lg-12 ">
                      <div className="position-relative "></div>
                    </div>
                  </div>
                  <Fileuploader />
                  <div className="row"></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default UserMyMedicalReport;
